module.exports = __webpack_public_path__ + "images/emoji/joy.2c60c45bd91275498f34.png";